import { Component, Watch, Vue } from 'vue-property-decorator';
import Footer from '../../../../shared/Footer/footer.vue';
import { Models } from '../../../../models/models';
import { CommonConfig } from '../../../../configs/config.common';
import AboutMe from '../../../../shared/AboutMe/about.me.vue';
import BlogList from '../../../../shared/BlogList/blog.list.vue';
import PropertyList from '../../../../shared/PropertyList/property.list.vue';
import Banner from '../../../../shared/Banner/banner.vue';
import Internationalizer from '../../../../shared/Internationalizer/internationalizer.vue';
import { UserInfoDelegate } from '../../../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import { WechatDelegate } from '../../../../services/DataDelegate/WechatDelegate/wechat.delegate';
import * as T_T from 'cryface';
import { HimuraInject } from 'himura';
import ContactAgent from '../../../../shared/ContactAgent/contact.agent.vue';

@Component({
   components: {
      Footer,
      AboutMe,
      Banner,
      BlogList,
      PropertyList,
      Internationalizer,
      ContactAgent
   }
})
export default class HomeDemo extends Vue {
   public title: string = 'HomeDemo';

   public configs = new CommonConfig();

   public isLoading = false;

   public userInfoService = new UserInfoDelegate();

   public wechat = new WechatDelegate();

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public async onUserChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.value)) {
         this.isLoading = true;
         await this.configuringWX(val);
         await T_T.delay(500);
         this.isLoading = false;
      }
   }

   public async created() {
   }

   public async onScreenClick() {
   }

   public async configuringWX(val: any) {
      if (this.wechat.isWeChat()) {
         const entry = HimuraInject.Injector.getInstance().getResourceByKey('entryUrl')!.value;
         const link = this.wechat.isWechatIos() ? entry.split('#')[0] : location.href.split('#')[0];
         const shareConfig: Models.IWechatShareConfig = {
            title: `我的房源门店`,
            desc: `欢迎光临${val.value.agentName}的房源门店`,
            link: location.href.split('#')[0],
            imgUrl: T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : '',
            success: () => {
            }
         };
         const wx = require('weixin-js-sdk');
         const options = await this.wechat.getConfig(link);
         wx.config(options);
         try {
            await this.wechat.ReadyPromise(wx);
            this.wechat.share(wx, shareConfig);
         } catch (e) {
            alert(e.errMsg);
            alert(location.href);
         }
      }
   }
}
